"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveAwardTier = resolveAwardTier;
exports.resolveStrategyIds = resolveStrategyIds;
exports.resolveAwardedCardId = resolveAwardedCardId;
exports.resolveAwardedCardIds = resolveAwardedCardIds;
const campaign_config_1 = require("./campaign.config");
const FIXED_AWARDED_CARD = {
    15000000: '2000',
    40000000: '4000',
    100000000: '8000',
    500000000: '35000',
    1000000000: '65000',
    2000000000: '1000000',
};
/** 取最高命中档。未达 1 万返回 null。 */
function resolveAwardTier(netHkdCents, config = campaign_config_1.nupCampaignConfig) {
    const hit = [...config.tiers]
        .filter((tier) => netHkdCents >= tier.minAmount)
        .sort((a, b) => b.minAmount - a.minAmount);
    return hit[0] ?? null;
}
/**
 * 解析本轮要发的 benefit 策略。
 * ≥ 1 万必含 4 选 1；再命中 ≥ 15 万则追加最高现金券档。现金券档之间仍取最高一档。
 */
function resolveStrategyIds(netHkdCents, choiceKey, config = campaign_config_1.nupCampaignConfig, isProdEnv = false) {
    if (netHkdCents < campaign_config_1.MIN_AWARD_AMOUNT_HKD_CENTS) {
        return [];
    }
    const pick = (item) => {
        return isProdEnv ? item.prod : item.test;
    };
    const ids = [];
    const choiceTier = config.tiers.find((tier) => tier.type === 'choice');
    if (choiceTier && choiceTier.type === 'choice') {
        const choiceId = pick(choiceTier.strategyIds[choiceKey]);
        if (choiceId) {
            ids.push(choiceId);
        }
    }
    const top = resolveAwardTier(netHkdCents, config);
    if (top && top.type === 'fixed') {
        const fixedId = pick(top.strategyId);
        if (fixedId) {
            ids.push(fixedId);
        }
    }
    return ids;
}
/** 按净入金档位解析获奖卡。未结算或未达门槛返回 null。 */
function resolveAwardedCardId(netHkdCents, choiceKey, config = campaign_config_1.nupCampaignConfig) {
    const ids = resolveAwardedCardIds(netHkdCents, choiceKey, config);
    return ids[ids.length - 1] ?? null;
}
/** 已获得卡列表：≥1 万含 4 选 1，≥15 万再叠加最高现金券。 */
function resolveAwardedCardIds(netHkdCents, choiceKey, config = campaign_config_1.nupCampaignConfig) {
    if (netHkdCents == null || netHkdCents < campaign_config_1.MIN_AWARD_AMOUNT_HKD_CENTS) {
        return [];
    }
    const ids = [choiceKey];
    const top = resolveAwardTier(netHkdCents, config);
    if (top && top.type === 'fixed') {
        const voucher = FIXED_AWARDED_CARD[top.minAmount];
        if (voucher) {
            ids.push(voucher);
        }
    }
    return ids;
}
